/*! @azure/msal-common v14.12.0 2024-06-10 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.12.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
